import React, { useState } from "react";
import { Icon } from "@iconify/react";
import styles from "./RefundTab.module.css";

export default function RefundTab() {
  const [isLoading, setIsLoading] = useState(false);

  // mock data - in real app this would come from API
  const refundData = {
    availableAmount: "0.00",
    lastRefundDate: null,
    totalRefunded: "0.00",
    eligibleForRefund: false,
    minimumLoss: 100,
    refundPercentage: 10,
  };

  const handleClaimRefund = async () => {
    if (!refundData.eligibleForRefund || isLoading) return;

    setIsLoading(true);
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 2000));
    setIsLoading(false);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.iconWrapper}>
          <svg
            className={styles.icon}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z"
              fill="currentColor"
            />
            <path
              d="M8 12L11 15L16 10"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h4 className={styles.title}>💰 คืนยอดเสีย</h4>
        <p className={styles.subtitle}>รับเงินคืนจากยอดเสียของท่าน</p>
      </div>

      <div className={styles.mainCard}>
        <div className={styles.promoHeader}>
          <div className={styles.promoBadge}>
            <Icon icon="solar:gift-bold" width={18} height={18} />
            <span>โปรโมชั่นพิเศษ</span>
          </div>
          <div className={styles.promoTitle}>
            <h3>คืนยอดเสีย {refundData.refundPercentage}%</h3>
          </div>
        </div>

        <div className={styles.detailsGrid}>
          <div className={styles.detailCard}>
            <div className={styles.detailIcon}>
              <Icon
                icon="solar:money-bag-bold-duotone"
                width={32}
                height={32}
              />
            </div>
            <div className={styles.detailContent}>
              <div className={styles.detailLabel}>ยอดขั้นต่ำ</div>
              <div className={styles.detailValue}>
                {refundData.minimumLoss.toLocaleString()} บาท
              </div>
            </div>
          </div>

          <div className={styles.detailCard}>
            <div className={styles.detailIcon}>
              <Icon icon="solar:chart-bold-duotone" width={32} height={32} />
            </div>
            <div className={styles.detailContent}>
              <div className={styles.detailLabel}>อัตราคืน</div>
              <div className={styles.detailValue}>
                {refundData.refundPercentage}%
              </div>
            </div>
          </div>
        </div>

        <div className={styles.claimAmountSection}>
          <div className={styles.claimAmountLabel}>จำนวนเงินที่รับได้</div>
          <div className={styles.claimAmountValue}>
            <span className={styles.claimCurrency}>฿</span>
            <span className={styles.claimAmount}>
              {refundData.availableAmount}
            </span>
          </div>
        </div>

        {refundData.eligibleForRefund ? (
          <button
            className={`${styles.claimButton} ${
              isLoading ? styles.loading : ""
            }`}
            onClick={handleClaimRefund}
            disabled={isLoading}
          >
            <span className={styles.buttonContent}>
              {isLoading ? (
                <>
                  <div className={styles.spinner}></div>
                  กำลังดำเนินการ...
                </>
              ) : (
                <>
                  <svg
                    className={styles.buttonIcon}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 10L12 15L17 10"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  รับเงินคืนทันที
                </>
              )}
            </span>
          </button>
        ) : (
          <div className={styles.notEligible}>
            <div className={styles.notEligibleIcon}>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className={styles.notEligibleText}>
              <h4>ยังไม่สามารถรับเงินคืนได้</h4>
              <p>ขออภัยท่านไม่มียอดเสียที่สามารถรับเงินคืนได้ในขณะนี้</p>
            </div>
          </div>
        )}
      </div>

      <div className={styles.infoCard}>
        <div className={styles.infoHeader}>
          <svg
            className={styles.infoIcon}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span style={{ color: "#111827" }}>เงื่อนไขการรับเงินคืน</span>
        </div>
        <div className={styles.infoContent}>
          <ul className={styles.conditionsList}>
            <li>
              • ยอดเสียขั้นต่ำ {refundData.minimumLoss.toLocaleString()} บาท
            </li>
            <li>• รับเงินคืน {refundData.refundPercentage}% ของยอดเสีย</li>
            <li>• สามารถรับได้วันละ 1 ครั้ง</li>
            <li>• ไม่มีเงื่อนไขการเทิร์น</li>
            <li>• เงินคืนจะเข้าสู่บัญชีทันที</li>
          </ul>
        </div>
      </div>

      {refundData.lastRefundDate && (
        <div className={styles.historyCard}>
          <div className={styles.historyHeader}>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 8V12L16 16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>ประวัติการรับเงินคืนล่าสุด</span>
          </div>
          <div className={styles.historyContent}>
            <p>รับเงินคืนครั้งล่าสุด: {refundData.lastRefundDate}</p>
          </div>
        </div>
      )}
    </div>
  );
}
